import { MenuItem } from "@kaltura/ds-react-components";
import { useState } from "react";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { GuestAccessModal, GuestAccessProps } from "./guest-access-modal/GuestAccessModal";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType, SharedMenuItemProps } from "@kaltura/mediaspace-shared-types";

interface GuestAccessMenuItemProps extends SharedMenuItemProps, GuestAccessProps {}

/**
 * Guest access menu item for media-page in title area actions menu
 */
export const GuestAccessMenuItem = (props: GuestAccessMenuItemProps) => {
    const { autoFocus, onCloseMenu, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState(false);
    const sendButtonAnalytics = useButtonAnalytics();

    const openModal = () => {
        setIsOpen(true);
        sendButtonAnalytics(
            "Manage Guest access",
            ButtonClickAnalyticsType.OPEN,
            props.entryId,
            "invitetomedia",
            "Media actions menu"
        );
    };

    const closeModal = () => {
        setIsOpen(false);
        onCloseMenu?.();
    };

    return (
        <>
            <MenuItem onClick={openModal} autoFocus={autoFocus}>
                {translate("Manage guest access")}
            </MenuItem>
            <ButtonAnalyticsProvider applicationFeature={"invitetomedia"} location={"Manage guest access modal"}>
                <GuestAccessModal {...modalProps} isOpen={isOpen} onClose={closeModal} />
            </ButtonAnalyticsProvider>
        </>
    );
};
